// Phosphor icons (MIT) used by the HUD, inlined at build time so they work offline.
import arrowsClockwise from '@phosphor-icons/core/assets/bold/arrow-clockwise-bold.svg?raw';
import arrowsOutCardinal from '@phosphor-icons/core/assets/bold/arrows-out-cardinal-bold.svg?raw';
import caretDown from '@phosphor-icons/core/assets/bold/caret-down-bold.svg?raw';
import caretLeft from '@phosphor-icons/core/assets/bold/caret-left-bold.svg?raw';
import check from '@phosphor-icons/core/assets/bold/check-bold.svg?raw';
import gaugeBold from '@phosphor-icons/core/assets/bold/gauge-bold.svg?raw';
import signIn from '@phosphor-icons/core/assets/bold/sign-in-bold.svg?raw';
import undo from '@phosphor-icons/core/assets/bold/arrow-u-up-left-bold.svg?raw';
import redo from '@phosphor-icons/core/assets/bold/arrow-u-up-right-bold.svg?raw';
import close from '@phosphor-icons/core/assets/bold/x-bold.svg?raw';
import checkCircle from '@phosphor-icons/core/assets/fill/check-circle-fill.svg?raw';
import cube from '@phosphor-icons/core/assets/fill/cube-fill.svg?raw';
import fastForward from '@phosphor-icons/core/assets/fill/fast-forward-fill.svg?raw';
import gauge from '@phosphor-icons/core/assets/fill/gauge-fill.svg?raw';
import hourglass from '@phosphor-icons/core/assets/fill/hourglass-medium-fill.svg?raw';
import info from '@phosphor-icons/core/assets/fill/info-fill.svg?raw';
import linkBreak from '@phosphor-icons/core/assets/fill/link-break-fill.svg?raw';
import lockSimple from '@phosphor-icons/core/assets/fill/lock-simple-fill.svg?raw';
import pause from '@phosphor-icons/core/assets/fill/pause-fill.svg?raw';
import trash from '@phosphor-icons/core/assets/fill/trash-fill.svg?raw';
import wifiSlash from '@phosphor-icons/core/assets/fill/wifi-slash-fill.svg?raw';

export const ICONS = {
  gauge,
  gaugeBold,
  lockSimple,
  arrowsClockwise,
  arrowsOutCardinal,
  caretDown,
  caretLeft,
  check,
  checkCircle,
  close,
  cube,
  fastForward,
  hourglass,
  info,
  linkBreak,
  pause,
  redo,
  signIn,
  trash,
  undo,
  wifiSlash,
} as const;
